import type { SessionStepDto } from '../../schemas/sessionSchemas';

// Face Match — but NOT the Liveness step (its own module). Old steps may carry
// a combined display name ("Face & Liveness Check"), so the stepType decides.
export function isFaceStep(step: SessionStepDto) {
  const t = step.stepType.toLowerCase();
  if (t.includes('liveness')) return false;
  return t.includes('face') || /face/i.test(step.displayName);
}
